import React from "react";

import Link from "@mui/material/Link";

import analytics from "services/analytics";
import { AnalyticsEvents } from "./analytics";

export const accordionData = [
  {
    title: "Що таке посилання на оплату в сервісі IBAN oplata?",
    text: "Посилання на оплату в IBAN oplata - це спеціальний лінк, який містить усі потрібні реквізити платежу (IBAN, суму, призначення). Ви надсилаєте це посилання клієнту в будь-який месенджер чи емейлом, клієнт переходить за ним, обирає свій банк і оплачує рахунок у кілька кліків без ручного введення реквізитів.",
  },
  {
    title: "Чи потрібен чек при оплаті на IBAN?",
    text: (
      <>
        Нагадуємо, що при розрахунку на IBAN чек (фіскалізація) не потрібен.
        Якщо ж ви хочете також приймати готівкові оплати та видавати фіскальні
        чеки — потрібно зареєструвати ПРРО{" "}
        <Link
          target="_blank"
          href="https://fopkasa.com"
          sx={{ cursor: "pointer" }}
          onClick={() => {
            analytics().sendEvent(
              AnalyticsEvents.iban_oplata_faq_fopkasa_click,
            );
          }}
        >
          ФОПкаса
        </Link>
        .
      </>
    ),
  },
  {
    title: "Що таке оплата по IBAN?",
    text: "Оплата по IBAN - це офіційний безготівковий платіж на розрахунковий рахунок підприємця (ФОП або ТОВ). На відміну від переказу «з картки на картку», цей метод є абсолютно прозорим для податкової та банку. За допомогою нашого сервісу такий платіж за реквізитами стає таким же простим, як звичайний переказ: клієнту не потрібно копіювати довгі коди  - він просто переходить за посиланням, а всі реквізити та призначення платежу вже заповнені в його банківському застосунку.",
  },
  {
    title:
      "З яких пристроїв та через які банківські застосунки клієнти можуть відкрити QR код на здійснити оплату?",
    text: "Для користування IBAN oplata підійде будь-який пристрій з банківськими застосунками (смартфони або планшети). Автоматично працюватиме з Приватбанк, Монобанк та близько двадцяти додатків інших провідних банків. Також завжди можна вставити реквізити вручну у всіх інших випадках.",
  },
  {
    title: "Чи може клієнт змінити суму чи призначення платежу?",
    text: "Так. Коли клієнт переходить за QR кодом, то усі дані вносяться автоматично, проте є можливість перевірити інформацію та за потреби внести зміни вручну перед підтвердженням оплати.",
  },
  {
    title: "Чи потрібна реєстрація в РРО?",
    text: "Оплата через наш сервіс - це прямий безготівковий переказ на IBAN (не еквайринг). Для абсолютної більшості КВЕДів та товарів ПРРО при таких операціях не потрібен. (Виняток - підакцизні або специфічні групи товарів, що підлягають обов'язковій фіскалізації за законом).",
  },
  {
    title: "Чи можна інтегрувати IBAN oplata з інтернет-магазином чи CRM?",
    text: "Так, IBAN oplata підтримує інтеграцію з інтернет-магазинами, CRM та іншими системами через IBAN oplata API. Це дає змогу автоматизувати створення платіжних та подальший їх менеджмент.",
  },
  {
    title: "Чи є ліміти на суми переказів через IBAN oplata?",
    text: "З 1 жовтня 2024 року Національний банк України встановлює обмеження на перекази коштів між банківськими картками фізичних осіб. Такі транзакції позначаються як P2P (Person-To-Person). НБУ має намір на півроку встановити ліміти на переказ коштів (вихідні P2P-перекази) до 150 000 грн на місяць.\nПepекази підпpиємцям не виняток, бо часто онлайн- чи офлайн-магазини пpиймають кошти на особисті карткові рахунки, які не пpизначені для підпpиємницької діяльності.\nДoxоди, щo надходять на карткові рахунки фізичної особи підлягають декларуванню, і за них потрібно сплачувати податки у розмірі – 18% ПДФО і 1,5% військовий збіp.\nДля ведення підприємницької діяльності потрібно використовувати окремий рахунок для ФОП та приймати оплату за IBAN-реквізитами. Це зручно робити з сервісом IBAN oplata. Створюйте посилання для швидких оплат та надсилате клієнтам у зручний спосіб. Це зекономить час та вбереже від штрафів.",
  },
  {
    title: "Що таке еквайринг?",
    text: "Еквайринг — це сервіс, що дозволяє підприємцям приймати безготівкові платежі за допомогою банківських карток через POS-термінали або онлайн. Сервіс IBAN oplata є альтернативою традиційному еквайрингу, оскільки дає змогу приймати платежі напряму на рахунок без посередників і комісій.",
  },
  {
    title: "Що таке оплата за реквізитами?",
    text: "Оплата за реквізитами — це переказ коштів із вашого банківського рахунку або карти на розрахунковий рахунок іншої фізичної чи юридичної особи через міжнародний ідентифікатор рахунку IBAN, із зазначенням найменування отримувача, податкового коду й призначення платежу.",
  },
  {
    title: "Наскільки безпечні платежі через IBAN oplata?",
    text: "Платежі через IBAN oplata безпечні, оскільки сервіс не є посередником і не приймає кошти на проміжні рахунки. Гроші надходять напряму на ваш банківський рахунок, а IBAN oplata не зберігає доступи чи ключі до банківських систем. Усі реквізити формуються для переказу через офіційні банківські застосунки платника, а підтвердження платежу відбувається лише в банку клієнта.",
  },
];
